/**
 * TB学堂相关接口
 */
import http, { BASE_NAME } from './index.js';

/**
 * 首页课程
 */
export async function getCourseHome(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/home`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得课程分页
 */
export async function getCoursePage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得课程基本信息
 */
export async function getCourseDetail(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/detail`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 短课详情
 */
export async function getCourseShortDetail(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/short/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建课程评价
 */
export async function postCourseEvaluate(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/evaluate/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建课程评价
 */
export async function getCourseEvaluate(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/evaluate/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得课程考试
 */
export async function getCourseExam(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/examination-paper/detail`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建课程考试记录
 */
export async function postExamRecordCreate(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/exam/record/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建课程练习记录
 */
export async function postPracticeCreate(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course-practice-answer/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 清除课程练习记录
 */
export async function deletePractice(value) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course-practice-answer/clear`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *  考试评分
 */
export async function getExamScore(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/exam/answer/submit`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 考试答案
 */
export async function postExamAnswerCreate(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/exam/answer/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得某次考试的答案
 */
export async function getExamAnswer(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/exam/answer/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得某次练习题的答案
 */
export async function getPracticeAnswer(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course-practice-answer/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程热销榜
 */
export async function getCourseHot(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/hot`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取视频资源信息
 */
export async function getSourceVideo(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/source/video/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 首页显示的短课程
 */
export async function getCourseShortHome(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/short/home`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得短课分组分页
 */
export async function getCourseShortGroupPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/short/group-page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得短课分页
 */
export async function getSchoolCourseShortPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/short/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新学习进度
 */
export async function putCourseLearnProgress(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/learn/progress/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程讲义下载
 */
export async function getCourseDocument(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/source/document/download/`, {
      params: value,
      responseType: 'blob',
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取课程讲义信息
 */
export async function getCourseDocumentDetail(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/source/document/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得订单课程分页
 */
export async function getOrderMyCourse(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/my-course/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 判断服务套餐中的课程是否已经购买
 */
export async function getOrderMyCourseOrdered(values) {
  try {
    const data = await http.get(`${BASE_NAME}/school/my-course/course-ordered`, {
      params: values,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建课程考试记录
 */
export async function postMyCourseCreate(values) {
  try {
    const data = await http.post(`${BASE_NAME}/school/my-course/create`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新视频播放次数
 */
export async function putCourseUpdatePlayTimes(values) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/update-play-times`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 记录三分钟课程播放次数
 */
export async function putCourseShortUpdateLearnTimes(values) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/short/update-learn-times`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取某个讲师的某个合集的课程
 */
export async function getCourseShortCollectionCourse(values) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/short/collection-course`, {
      params: values,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程点赞
 */
export async function putCourseShortLike(values) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/short/like`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程取消点赞
 */
export async function putCourseShortLikeCancel(values) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/short/like-cancel`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程收藏
 */
export async function putCourseShortCollect(values) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/short/collect`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程取消收藏
 */
export async function putCourseShortCollectCancel(values) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/short/collect-cancel`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 我的收藏
 */
export async function getMyCollect(values) {
  try {
    const data = await http.get(`${BASE_NAME}/school/my-course/my-collect`, {
      params: values,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 根据专家id获取课程信息
 */
export async function getCourseByExpertId(params) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/get-course`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 根据专家id获取推荐课程信息
 */
export async function getRecommendCourseByExpertId(params) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/get-recommend-course`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 根据专家id获取短课信息
 */
export async function getCourseShortListByExpertId(params) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/short/list-by-expertId`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取用户讲师认证信息
 */
export async function getLecture() {
  try {
    return await http.get(`${BASE_NAME}/school/lecturer/get`);
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取用户讲师认证信息
 */
export async function lectureSubmit(data) {
  try {
    return await http.post(`${BASE_NAME}/school/lecturer/submit`, data);
  } catch (error) {
    console.error(error);
  }
}

// 创建课程修订
export async function createCourseReversion(id) {
  return await http.get(`${BASE_NAME}/school/course/create-reversion?id=${id}`);
}

// 更新切屏次数
export async function putScreenSwitchCount(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/exam/record/update-screen-switch-count`, { params: value });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 我关注的讲师
export async function getMyAttentionLecturer(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/lecturer/page`, { params: value });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 获取全部上架的讲师
export async function getAllLecturer() {
  try {
    const data = await http.get(`${BASE_NAME}/school/lecturer/list`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取讲师信息
 */
export async function getLectureInfo(params) {
  try {
    return await http.get(`${BASE_NAME}/school/lecturer/detail`, { params });
  } catch (error) {
    console.error(error);
  }
}

// 关注
export async function putLecturerCollect(lecturerId) {
  try {
    const data = await http.put(`${BASE_NAME}/school/lecturer/collect?lecturerId=${lecturerId}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 取消关注
export async function putLecturerCollectCancel(lecturerId) {
  try {
    const data = await http.put(`${BASE_NAME}/school/lecturer/collect-cancel?lecturerId=${lecturerId}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}
